import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'productDetail',
    component: () => import('../views/product-detail.vue'),
    meta: {
      displayName: '平安健康险',
      keepAlive: true
    }
  },
  {
    path: '/product-detail',
    name: 'ProductDetail',
    component: () => import('../views/product-detail.vue'),
    meta: {
      displayName: '平安健康险',
      keepAlive: true
    }
  },
  {
    path: '/health-notice',
    name: 'HealthNotice',
    component: () => import('../views/health-notice.vue'),
    meta: {
      displayName: '健康告知-平安健康险'
    }
  },
  {
    path: '/insurance-plan',
    name: 'insurancePlan',
    component: () => import('../views/insurance-plan.vue'),
    meta: {
      displayName: '保障计划详情-平安健康险'
    }
  },
  {
    path: '/order-finish',
    name: 'OrderFinish',
    component: () => import('../views/order-finish.vue'),
    meta: {
      displayName: '订单完成-平安健康险'
    }
  },
  {
    path: '/order-finish-demo',
    name: 'OrderFinishDemo',
    component: () => import('../views/order-finish-demo.vue'),
    meta: {
      displayName: '订单完成预览-平安健康险'
    }
  },
  {
    path: '/third-page',
    name: 'ThirdPage',
    component: () => import('../views/third-page.vue'),
    meta: {
      displayName: '平安健康险'
    }
  },
  {
    path: '/question-detail',
    name: 'QuestionDetail',
    component: () => import('../views/pages-101/question-detail.vue'),
    meta: {
      displayName: '常见问题-平安健康险'
    }
  },
  {
    path: '/clear-cookie',
    name: 'ClearCookie',
    component: () => import('../views/clear-cookie.vue'),
    meta: {
      displayName: '平安健康险'
    }
  },
  {
    path: '/bind-card',
    name: 'BindCard',
    component: () => import('../views/bind-card.vue'),
    meta: {
      displayName: '绑定银行卡-平安健康险'
    }
  },
]

// 404 页
routes.push({path: '*', component: () => import('../views/notfound.vue'), name: 'notfound'});

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
})

export default router
